






























































































import Vue, { VueConstructor } from 'vue';
import { FormatterHelper } from '../../../common/utils/FormatterHelper';
import { SearchCustomerVm, CustomerVm } from '../viewModel';
import { SearchParams } from '../../../models/api-client';

export default (Vue as VueConstructor<Vue & {
}>).extend({
  name: 'CustomerTable',
  props: {
    customerFoundtList: {
      type: Array as () => SearchCustomerVm[],
      required: false,
      default: null,
    },
    searchParams: {
      type: Object as () => SearchParams,
      required: false,
      default: null,
    },
    hasSearch: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      page: 0 as number,
      selectedCustomerData: {} as CustomerVm,
      isMobile: false as boolean,
      selectedCustomerId: '',
      selected: [],
      headers: [
        { text: 'Nachname', value: 'anspName', class: 'black--text' },
        { text: 'Zusatztext', value: 'anspZusatztext', class: 'black--text' },
        { text: 'Postleitzahl', value: 'adrePlz', class: 'black--text' },
        { text: 'Ort', value: 'adreOrt', class: 'black--text' },
        { text: 'Straße', value: 'adreStrasse', class: 'black--text' },
        { text: 'Land', value: 'adreLand', class: 'black--text' },
        { text: 'Telefon privat', value: 'anspTelPrivat', class: 'black--text' },
        { text: 'Telefon geschäftlich', value: 'anspTelGesch', class: 'black--text' },
        { text: 'Telefon alternativ', value: 'anspTelAlternativ', class: 'black--text' },
        { text: 'Telefon mobil', value: 'anspMobil', class: 'black--text' },
      ],
    };
  },
  computed: {
    pagination: {
      get() {
        return this.$store.getters['storeTable/getPagination'];
      },
      set(value) {
        this.$store.commit('storeTable/setPagination', value);
      },
    },
    items() {
      return this.$store.getters['storeTable/getItems'];
    },
    loading() {
      return this.$store.getters['storeTable/getLoading'];
    },
  },
  methods: {
    checkImplementationStatus(pagination: any) {
      if (this.hasSearch) {
        this.$store.dispatch('storeTable/setPaginationRowPerPage', pagination.rowsPerPage);
        this.searchParams.paginator.currentItems = pagination.page - 1;
        this.searchParams.paginator.rowsPerPage = pagination.rowsPerPage;
        if (pagination.descending) {
          this.searchParams.paginator.order = 'DESC';
        } else {
          this.searchParams.paginator.order = 'ASC';
        }
        this.searchParams.paginator.sortBy = FormatterHelper.capitalizeFirstLetter(pagination.sortBy);
        this.$store.dispatch('storeTable/queryItems', this.searchParams);
      } else {
        this.$emit('hasNotSearch', this.hasSearch);
      }
    },
    onResize() {
      if (window.innerWidth < 769) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    selectCustomer(props: any) {
      if (this.selectedCustomerId === props.item.id) {
        this.selectedCustomerId = '';
      } else {
        this.selectedCustomerId = props.item.id;
      }
      this.selectedCustomerData = props.item;
    },
    submitForm(props: any) {
      this.selectCustomer(props);
      this.pagination.totalItems = 0;
      this.$router.push({
        name: 'SelectedCustomer',
        params: {
          id: this.selectedCustomerData.id.toString(),
        },
      });
    },
  },
});
